<template>
  <div class="news-all">
    <div class="title"><span class="time">02.05<br>2019</span><span class="tiel">美菜网，站好新鲜食材的最后一班岗</span></div>
    <div class="mat-content">

        <div class="tet-js">
          在城市当中，总有这样的一批人，他们无法与家人团聚，甚至连团圆饭也会错过，这些人坚守着自己的岗位，坚守着自己的工作，独自身处异乡。那么，他们是如何在新年里独自一人在外还吃到新鲜又美味的饭菜呢？后来发现是美菜网，站好了新鲜食材的最后一班岗。<br/><br/>
          我想对于陶平和朱宗翠夫妇来说，2019年2月1日的那个中午，一定是很难忘的一天，因为在这一天，国家领导人来到他们位于北京市西城区大栅栏街道石头胡同127号淮南牛肉汤馆的情景。但是却有很多人好奇了，毕竟都腊月二十七了，他们夫妇不回家过年吗？即便不回，开一家餐馆，春节期间上哪儿去买菜来维持餐馆的正常营业呢？<br/><br/>
          在朱宗翠的讲述中，一群人进入我们的视野，也因为他们的值守，才成就了许许多多人在春节之际吃上极具仪式感的年夜饭。
            <br/><br/>
        </div>

        <p align="center"><img src="@/assets/images/new-img/c010_1.jpg" width="640"></p>
        <div class="tet-js" style="text-align: center">
          美菜网配送司机
        </div>

        <div class="title-bold"><span></span>"如果我们不值守，餐厅就不能安心做年夜饭了"</div>
        <div class="tet-js">
            蒋安虎，26岁，第2次值守<br/><br/>
            上海美菜网，负责虹口区配送<br/><br/>
            虹口区有很多中餐厅，他们都会在这时候推出年夜饭活动，这几年，也有越来越多的人选择去餐厅吃年夜饭，加上春节是中国人团圆的大日子，餐厅当然得做好一年一次的团圆饭了，所以，我们也不打烊，我们还得配好菜，我们也希望更多人吃上放心可口的年夜饭。<br/><br/>
            虽然今年又没回去，但爱人很支持我，还带着1岁的宝宝来上海陪我，但是对家中的老人很愧疚，没能回家陪他们过年还是很遗憾。2019年，我想多挣点钱，和家人一起过快乐生活，减轻家中的负担。
            <br/><br/>
        </div>

        <p align="center"><img src="@/assets/images/new-img/c010_2.jpg" width="640"></p>
        <div class="tet-js" style="text-align: center">
            美菜网配送员
        </div>

        <div class="title-bold"><span></span>"餐厅不打烊，我们更不能打烊"</div>
        <div class="tet-js">
          刘辉，41岁，春节值守第三年<br/><br/>
          上海美菜网，负责杨浦区配送<br/><br/>
          今年春节不打烊的餐厅比往年还多，很多商户都提前打电话问我们春节还送不送菜。他们不打烊，我们当然更不能打烊。我是美菜网的老员工，我觉得只有服务好商户，信守对他们的承诺，才能得到商户认可，有口碑了，公司发展才能红火，我们明年肯定有更多商户用美菜！<br/><br/>
          算上今年，我是第三次值守春节没有回家过年了。头两年，因为没有什么积蓄，虽说是有钱没钱也要回家过年，但我是家里的顶梁柱，没钱不好意思回去，今年生活有了起色，就把老婆孩子接到上海来一起过年。<br/><br/>
          这么拼命也是想，公司发展红火了，我也能家人的日子过得红火。
          <br/><br/>
        </div>

        <p align="center"><img src="@/assets/images/new-img/c010_3.jpg" width="640"></p>
        <div class="tet-js" style="text-align: center">
          美菜网客服接线员
        </div>

        <div class="title-bold"><span></span>"春节，餐厅对新鲜食材的要求更迫切"</div>
        <div class="tet-js">
          王德胜，43岁，春节值守第一年<br/><br/>
          上海美菜网，负责普陀区曹杨片区配送<br/><br/>
          春节期间，像上海这样大的城市，其实有很多餐厅都不打烊，像我负责的"老妈烫饭"、"牛角尖"都照常营业。但很多菜场都歇业了，他们买不到新鲜菜很着急，总不能囤菜吧，囤了就不新鲜，食材不新鲜，还怎么做生意。因此，我们也不能打烊，过节也得坚守。<br/><br/>
          我爱人和小孩都在上海，都特别支持我工作，爱人还常常说，不管在哪里工作，都要尽职尽责，所以，我今年值守岗位，她一点怨言没有，这些天家家户户都在准备年夜饭，我们家的年夜饭就交给我爱人负责了。
            <br/><br/>
        </div>

        <p align="center"><img src="@/assets/images/new-img/c010_4.jpg" width="640"></p>
        <div class="tet-js" style="text-align: center">
          美菜网销售
        </div>
        <div class="title-bold"><span></span>"春节打烊，就是给餐厅拖后腿"</div>
        <div class="tet-js">
            陈金海，36岁，春节值守第一年<br/><br/>
            重庆美菜网，负责渝中区配送<br/><br/>
            我负责配送的主要是渝中的龙湖时代天街、英利国际等，都是商业区，春节期间客流量更大，对开在商业区的商户来说，打烊就意味着错过了很好的营业节点。因此我们不能打烊，我们是商户的后勤保障，我们可不能拖了他们的后腿。<br/><br/>
            2019年1月，美菜网发起"春节不打烊"活动，在其业务覆盖的220座城市里，像刘辉、王德胜、陈金海、蒋安虎这样坚守一线，为千千万万的餐厅提供配送服务的司机还有很多很多。<br/><br/>
            当然还有马京飞，美菜网销售，他说："我曾经沉溺游戏，让妈妈操心了好久。现在我每天忙着跑市场，还把妈妈发展成了美菜商户"。马京飞说，找个好工作，让妈妈省点心，用美菜打点小店，让妈妈省点力。<br/><br/>
            还有这对小夫妻，孙霞，八仓库存组，王琪，九仓发运组。一个白班一个夜班，同时休息的时间一天不过两三个小时。孙霞说："他轮休的日子我不休，我休时他不休，咋都见不到面。"王琪说："跟CEO说说，把我俩调一个仓库呗？"共同成长，就是夫妻二人最长久的守候。<br/><br/>
            当然还有张宏伟，美菜网采购，他说："小时候，爸爸牵着我的手走路；长大后，老爸手把手教我做采购。"总暗自嘲笑老爸的"过时"，可张宏伟刚刚迈入采购这行的门槛，却是采购代办出身的老爸带着他一处处地跑地头，一家家地认收购点。站在老爸身后，才惊觉他头发少了，还长了白发。老爸那时候没赶上"美菜"啊，要不说不定现在身板还能更挺直一些，像小时候扛我在肩膀上那样。薪火相传，就是父子间最默契的肯定。<br/><br/>
            在春节这样阖家团圆的时刻，他们与人们熟知的警察、医生、列车员等等基层工作者一样，坚守岗位，做着最平凡不过的事，给千千万万的餐馆提供食材配送，让餐厅为有底气为更多人烹制年夜饭。<br/><br/>
            看到了这么多人为了我们的年夜饭奔波辛劳着，内心也是暖融融的，对于美菜网来说，让更多人吃上热气腾腾的团圆饭就是最大的成就，美菜网也在严冬当中为无法归家的游子送去了温暖，驱赶了城市当中的寒意。<br/><br/>
        </div>


        <!-- <div class="title-bold"><span></span>20年里的朴实无华</div> -->

        <!-- <p align="center"><img src="/assets/images/new-img/b011_1.jpg" width="640"></p>
        <div class="tet-js" style="text-align: center">
          牛角2018新零售创新标杆奖现场
        </div> -->

    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
